import React from "react";
import { Provider } from "react-redux";
import { Outlet } from "react-router-dom";
import { separationStore } from "./store";

export const MobileSeparation: React.FC = () => {
  return (
    <Provider store={separationStore}>
      <Outlet />
    </Provider>
  );
};
